export default __webpack_public_path__ + "static/liner_install_1-9aa4ce4cfe21f67fc8439f15ddf170dd.jpeg";